import { SeatMapFromValues } from "./types";

export const SEAT_MAP_FORM_INITIAL_VALUES: SeatMapFromValues = {
  input: {
    name: "",
  },
};
